module.exports = __webpack_public_path__ + "img/3_play_pause_stop_tutorial.ec8dd2f0.gif";